import { Tabs, Button } from "antd";
import type { TabsProps } from "antd";
import {
  DashboardTab,
  ManageSubscriptionsTab,
  TechSupportTab,
  PaymentHistoryTab,
  AccountInformationTab,
  HolidayCalendarTab,
} from "../../components/dashboard";
import styles from "./styles.module.css";
// import useAuth from '../../hooks/withAuth';


const Dashboard = () => {
  // useAuth(); // Call custom hook to handle authentication
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Dashboard",
      children: <DashboardTab />,
    },
    {
      key: "2",
      label: "Manage Subscriptions",
      children: <ManageSubscriptionsTab />,
    },
    {
      key: "3",
      label: "Tech Support",
      children: <TechSupportTab />,
    },
    // {
    //   key: "4",
    //   label: "Payment History",
    //   children: <PaymentHistoryTab />,
    // },
    // {
    //   key: "5",
    //   label: "Account Information",
    //   children: <AccountInformationTab />,
    // },
    {
      key: "4",
      label: "Holiday Calendar",
      children: <HolidayCalendarTab />,
    },
  ];
  const handleButtonClick = () => {
    console.log("Button clicked!");
  };
  

  return <Tabs defaultActiveKey="1" items={items} tabPosition="top"
  tabBarExtraContent={{
    right: (
      <div style={{ marginRight: "0px" }}>
        <Button type="primary" danger ghost href= {`${process.env.REACT_APP_PSA_URL || ""}/navigation`}>My Projects</Button>
      </div>
    ),
  }} />;
};

export default Dashboard;
